import RoutesEnum from 'enums/routes.enum'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import LoadSessionMiddleware from 'middlewares/LoadSessionMiddleware'

export default [
    {
        path: '/profile/:tabType',
        name: RoutesEnum.USER.ME,
        view: 'user/MyProfile',
        middlewares: [RequireUserMiddleware],
        meta: {
            layout: 'main',
            title: 'Moj Profil | Bookeraj',
            description:
                'Pregledajte svoj korisnički profil, ažurirajte informacije i postavke naloga. Prilagodite svoj profil prema svojim željama.',
        },
    },
    {
        path: '/user/:id/:tab',
        name: RoutesEnum.USER.PROFILE,
        view: 'user/UserProfile',
        middlewares: [LoadSessionMiddleware],
        meta: {
            layout: 'main',
            title: 'Korisnički Profil | Bookeraj',
            description:
                'Pregledajte i uređujte svoj korisnički profil. Dodajte ili ažurirajte informacije o sebi na našoj platformi.',
        },
    },
    {
        path: '/delete-account',
        name: RoutesEnum.USER.DELETE,
        view: 'user/Delete',
        meta: {
            layout: 'main',
            title: 'Korisnički Profil | Bookeraj',
            description:
                'Pregledajte i uređujte svoj korisnički profil. Dodajte ili ažurirajte informacije o sebi na našoj platformi.',
        },
    },
]
